import {Game} from "../Game";
import {GameUtils} from "../utils/GameUtils";
import {gsap} from "gsap";

export class LockFrame extends PIXI.Container {
    private readonly _reelId: number;
    private readonly _rowId: number;
    private _blinkTl: gsap.core.Timeline;

    constructor(reelId: number, rowId: number) {
        super();
        this._reelId = reelId;
        this._rowId = rowId;
        this.init();
    }

    public showHide(value: boolean): gsap.core.Tween {
        return value ? this.show() : this.hide();
    }

    public glowFadeIn(): gsap.core.Tween {
        const glow: PIXI.Sprite = <PIXI.Sprite>this.children[1];
        glow.visible = true;
        glow.alpha = 0;
        return gsap.to(glow, {alpha: 1, duration: 0.2});
    }

    public glowFadeOut(): gsap.core.Tween {
        const glow: PIXI.Sprite = <PIXI.Sprite>this.children[1];
        return gsap.to(glow, {
            alpha: 0, duration: 0.4, onComplete: () => {
                glow.visible = false;
            }
        });
    }

    public glowBlink(): gsap.core.Timeline {
        this._blinkTl = new gsap.core.Timeline({
            repeat: 50
        });
        const glow: PIXI.Sprite = <PIXI.Sprite>this.children[1];
        glow.visible = true;
        glow.alpha = 0;
        this._blinkTl.to(glow, {alpha: 1, duration: 0.2});
        this._blinkTl.to(glow, {duration: 0.1});
        this._blinkTl.to(glow, {alpha: 0, duration: 0.2});
        return this._blinkTl;
    }

    public stopBlink(): gsap.core.Tween {
        this._blinkTl?.paused();
        this._blinkTl?.kill();
        return this.glowFadeOut();
    }

    private show(): gsap.core.Tween {
        this.alpha = 0;
        return gsap.to(this, {
            alpha: 1, duration: 0.1, onStart: () => {
                this.visible = true;
            }
        });
    }

    private hide(): gsap.core.Tween {
        return gsap.to(this, {
            alpha: 0, duration: 0.1, onComplete: () => {
                this.visible = false;
            }
        });
    }

    private init(): void {
        const textureStr: string = (this._reelId === 2 && this._rowId === 0) ? "S1/S1_assets/jail_bar_half" : "S1/S1_assets/jail_bar";
        const lock: PIXI.Sprite = new PIXI.Sprite(Game.assetLoader.getTextures(textureStr)[0]);
        const lockGlow: PIXI.Sprite = new PIXI.Sprite(Game.assetLoader.getTextures(textureStr + "_shine_000")[0]);
        this.addChild(lock, lockGlow);
        this.name = "LOCK_" + this._reelId + "_" + this._rowId;
        const pos: PIXI.Point = GameUtils.getSymbolPos(this._reelId, this._rowId);
        lock.anchor.set(0.5);
        lockGlow.anchor.set(0.5);
        lockGlow.visible = false;
        this.position.set(pos.x, pos.y);
        this.visible = false;
    }
}